import { BannerAction, BannerType } from '@/src/api/payg/types';
import { Link, Strong } from '@ovotech/element-v5';
import React, { ReactNode } from 'react';

export const getNormalisedText = (text: string) => {
  if (!text || typeof text !== 'string') {
    return null;
  }

  // Split the text by the {bold} tag.
  // Every odd-indexed chunk will be the content that was between the tags.
  return text.split('{bold}').map((chunk, index) => {
    // For odd indices, the chunk was inside {bold} tags, so wrap it in <Strong>.
    // For even indices, it's just plain text.
    const Component = index % 2 === 1 ? Strong : 'span';
    const key = index + chunk;
    return <Component key={key}>{chunk}</Component>;
  });
};

export const getAlertType = (remoteType: string): BannerType => {
  if (
    remoteType === 'info' ||
    remoteType === 'success' ||
    remoteType === 'warning' ||
    remoteType === 'error'
  ) {
    return remoteType;
  }
  // Default to 'info' if the remote type is invalid or not provided
  return 'info';
};

const RUNNING_OUT_OF_CREDIT_URL =
  'https://www.ovoenergy.com/help/article/running-out-of-credit';

/**
 * The actions we know how to render, and what each one renders as. Typed as a
 * Record over BannerAction, so adding an action to the union fails to compile
 * until it has a link here.
 */
const BANNER_ACTION_LINKS: Record<BannerAction, ReactNode> = {
  emergency_credit_help: (
    <Link
      key="emergency_credit_help"
      href={RUNNING_OUT_OF_CREDIT_URL}
      target="_blank"
      iconRight="chevron-right"
    >
      Find out more
    </Link>
  ),
};

export const getExtraButtons = (actions: BannerAction[]): ReactNode =>
  actions.map(action => BANNER_ACTION_LINKS[action]);
